module.exports = __webpack_public_path__ + "media/recipes/66-e2f7539e.png";